import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
    container: {
        minHeight: "calc(100vh - 355px)",
        "@media (max-height: 600px)": {
            minHeight: "calc(100vh - 177px)",
        },
        "@media (max-height: 420px)": {
            minHeight: "100vh",
        }
    },
    header: {
        marginBottom: "26px"
    },
    title: {
        fontSize: "18px",
        fontFamily: "Manrope",
        fontWeight: 700,
        color: "#465869"
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end"
    },
    button: {
        cursor: "pointer"
    },
    buttonNone: {
        pointerEvents: "none",
    },
    statusBadge: {
        padding: "0px 10px",
        paddingTop: "1px",
        borderRadius: "20px",
        height: "24px",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "20px",
        color: "#FFF !important"
    },
    statusBadgeActive: {
        background: "#D1FADF !important",
        border: "1px solid #D1FADF",
        color: "#32D583 !important"
    },
    statusBadgeInactive: {
        background: "#FEE4E2 !important",
        border: "1px solid #D1FADF",
        color: "#F97066 !important"
    },
    statusBadgeUnavailable: {
        background: "rgba(152, 162, 179, 0.8) !important",
        border: "1px solid #D1FADF",
        color: "#FFF !important"
    },

    inputCharge: {
        width: "160px"
    },
    inputRate: {
        width: "140px"
    },
    inputCurrency: {
        minWidth: "135px"
    },
    flexRowCenter: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    mr4: {
        marginRight: "4px"
    }
}));

export default styles;

const getTextProperties = (fontSize: string) => ({
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize,
    color: "#465869",
})
